/**
 * Language Switcher
 * Small SV/EN toggle. Used in Layout's nav (post-login) and LoginPage's
 * header (pre-login), since locale is independent of auth.
 */

import { useLocaleStore, Locale } from "../stores/locale-store";

interface LanguageSwitcherProps {
  /** "dark" for use on the hero/login background, "light" for the app shell nav */
  variant?: "dark" | "light";
}

const LANGUAGES: { code: Locale; label: string }[] = [
  { code: "sv", label: "SV" },
  { code: "en", label: "EN" },
];

export default function LanguageSwitcher({
  variant = "light",
}: LanguageSwitcherProps) {
  const { language, setLanguage } = useLocaleStore();

  const baseClass =
    variant === "dark"
      ? "text-white/60 hover:text-white transition-colors"
      : "text-gray-500 hover:text-gray-800 transition-colors";
  const activeClass = variant === "dark" ? "text-white" : "text-gray-900";

  return (
    <div className="flex items-center space-x-1 text-sm font-medium" role="group" aria-label="Language">
      {LANGUAGES.map(({ code, label }, index) => (
        <span key={code} className="flex items-center">
          {index > 0 && (
            <span
              className={variant === "dark" ? "text-white/30 mx-1" : "text-gray-300 mx-1"}
              aria-hidden="true"
            >
              |
            </span>
          )}
          <button
            type="button"
            onClick={() => setLanguage(code)}
            aria-pressed={language === code}
            className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-md px-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${language === code ? activeClass : baseClass}`}
          >
            {label}
          </button>
        </span>
      ))}
    </div>
  );
}
